import {defaultError, WebError} from "@hybird/core/error";

class DeviceConnectProvide {
  _subscribeIndex = 0;
  /**
   *
   * @type {{String: {
   *  events:[{
   *   success: function(params),
   *   error: function(params),
   *   complete: function(params),
   *   message: function(params),
   *   name: String
   * }]}}}
   *
   */
  _subscribes = {};

  get id() {
    return `${parseInt((Math.random() * 4294967296).toString())}`;
  }

  get connectType() {
    return 0;
  }


  isSupport(connectType, config) {
    return this._connectType === connectType;
  }

  /**
   *
   * @param topic
   * @param success
   * @param message
   * @param complete
   * @param fail
   * @return {{
   *   success: function(params),
   *   fail: function(params),
   *   complete: function(params),
   *   message: function(params),
   *   name: String,
   *   index: String
   * }}
   * @private
   */
  _addSubscribe(topic, {success, message, complete, fail} = {}) {
    const fns = this.getSubscribe(topic);

    const subscribe = {
      success, fail, complete, "name": topic, index: `subscribe-${++this._subscribeIndex}`, message
    };
    fns.events.push(subscribe);

    return subscribe;
  }

  /**
   * 取消订阅, 删除订阅数据
   * @param topic
   * @param success
   * @param index
   * @return {{events: [{
   *   success: function(params),
   *   fail: function(params),
   *   complete: function(params),
   *   name: String,
   *   index: String
   * }]}}
   * @private
   */
  _removeSubscribe(topic, {success, index} = {}) {
    const fns = this.getSubscribe(topic);

    if (index) {
      fns.events = fns.events.filter((value) => value.index !== index);
    } else {
      fns.events = [];
    }

    return fns;
  }

  /**
   * 获取订阅对象数据
   * @param name
   * @return {{events: [{
   *   success: function(params),
   *   fail: function(params),
   *   complete: function(params),
   *   message: function(params),
   *   name: String,
   *   index: String
   * }]}}
   * @private
   */
  getSubscribe(name) {
    let fns;
    //获取存储数据
    if (this._subscribes[name]) {
      fns = this._subscribes[name];
    } else {
      this._subscribes[name] = fns = {events: []};
    }

    return fns;
  }

  /**
   * @param onConnect
   * @param onConnected
   * @param onReconnect
   * @param onDisconnect
   * @param onDisconnected
   * @param onError
   * @param config
   * @return Promise<DeviceConnectProvide>
   */
  async connect({onConnect, onConnected, onReconnect, onDisconnect, onDisconnected, onError, config} = {}) {
  }

  _onMessage(topic, payload) {
    const fns = this.getSubscribe(topic);

    const events = [...fns.events];
    for (const i in events) {
      try {
        events[i]?.message?.call(this, payload, async (params, {
          errorCode,
          error,
          success, message, complete, fail
        } = {}) => {
          if (!errorCode && error) {
            if (error instanceof WebError) {
              errorCode = {
                code: error.code,
                message: error.message
              };
            } else {
              errorCode = defaultError.SYSTEM_ERROR;
            }
          }

          await this._reply(topic, params, payload, {
            reply: true,
            errorCode, success, message, complete, fail
          })
        });
      } catch (e) {
        console.warn(`执行message异常 ${topic}, ${JSON.stringify(payload)}`, e);
        fns.events[i].fail?.call("执行message异常", payload);
      }
    }
  }

  async _reply(topic, params, payload, {
    reply = false,
    errorCode, success, complete, fail
  }) {

  }

  /**
   * @return Promise<void>
   */
  async close(force = false) {
  }

  /**
   * @return Promise<void>
   */
  async disconnect() {
  }

  /**
   * 当前连接状态
   * @return {boolean} true: 成功  false:未连接
   */
  get connected() {
    return false;
  }

  /**
   * 订阅
   * @param topic 订阅地址
   * @param id
   * @param filter
   * @param success 接口调用成功的回调函数
   * @param message
   * @param complete 接口调用结束的回调函数（调用成功、失败都会执行）
   * @param fail 调用失败
   * @return {Promise<String>}
   */
  async subscribe(topic, {
    id, filter = (params) => {
      return (!id || (id && id === params.id));
    }, success, message, complete, fail
  } = {}) {
    if (!this.connected) {
      fail?.call("请先连接再订阅");
      console.warn("未连接订阅", topic);
    }

    const fns = this.getSubscribe(topic);

    let subscribe;

    try {
      if (fns.events.length === 0) {
        subscribe = this._addSubscribe(topic, {message});

        await this._subscribe(topic, {
          message: params => {
            if (filter(params)) {
              message?.call(this, params);
            }
          }
        }).catch(e => {
          this._removeSubscribe(topic, {index: subscribe.index});
          throw e;
        })
        console.log("subscribe", topic, Date.now());
      } else {
        subscribe = this._addSubscribe(topic, {message});
      }

      await success?.call(this, subscribe.index);
      complete?.call(this, subscribe.index);
      return subscribe.index;
    } catch (e) {
      fail?.call(this, e);
      complete?.call(this, null, e);
      throw WebError.code(defaultError.SUBSCRIBE_ERROR, {error: e});
    }
  }

  /**
   * 订阅
   * @param topic 订阅地址
   * @param id
   * @param filter
   * @param success 接口调用成功的回调函数
   * @param message
   * @param complete 接口调用结束的回调函数（调用成功、失败都会执行）
   * @param fail 调用失败
   * @param timeout
   * @return {Promise<{code:Number, success: boolean, data: Object}>}
   */
  async subscribeOne(topic, {
    id, filter, success, message, complete, fail, timeout = 10
  } = {}) {
    let timeoutCallback;

    return new Promise((resolve, reject) => {
      let subscribeIndex;

      if (timeout > 0) {
        timeoutCallback = setTimeout(() => {
          const message = `${topic}, Result timeout, timeout: ${timeout}`;
          fail?.call(message);
          console.error(id, message);
          this.unsubscribe(topic, {index: subscribeIndex});
          reject(WebError.code(defaultError.SUBSCRIBE_ONE_READ_TIMEOUT));
        }, timeout * 1000);
      }

      this.subscribe(topic, {
        id, filter, success, complete, message: (params, reply) => {
          if (timeoutCallback) {
            clearTimeout(timeoutCallback);
            timeoutCallback = null;
          }

          message?.call(this, params, reply);
          this.unsubscribe(topic, {index: subscribeIndex});
          resolve(params);
        }, fail
      }).then(index => {
        subscribeIndex = index;
        return index;
      });
    });
  }

  /**
   * 取消监听
   * @param topic
   * @param success
   * @param error
   * @param complete
   * @param fail
   * @param index
   * @return {Promise<void>}
   */
  async unsubscribe(topic, {success, error, complete, fail, index} = {}) {
    const fns = this._removeSubscribe(topic, {index});

    if (fns.events.length === 0) {
      await this._unsubscribe(topic, {success, error, complete, fail, index});
    }
  }

  /**
   * 发送数据
   * @param topic
   * @param params
   * @param id
   * @param success
   * @param complete
   * @param fail
   * @return {Promise<void>}
   */
  async publish(topic, params, {id, success, complete, fail} = {}) {
    if (this.connected) {
      await this._publish(topic, params, {id, success, complete, fail});
    }
  }

  /**
   *
   * @param getTopic
   * @param putTopic
   * @param params
   * @param success
   * @param error
   * @param complete
   * @param fail
   * @param timeout
   * @return {Promise<{code:Number, success: boolean, data: Object}>}
   */
  async publishAndResult(getTopic, putTopic, params, {
    success, complete, message, fail, timeout = 10
  } = {}) {
    const id = this.id;
    return this.subscribeOne(getTopic, {
      id, message, fail, timeout, success: async () => {
        await this.publish(putTopic, params, {id, complete, fail});
        await success?.call(this);
      }
    }).then(data => {
      return data;
    }).catch(e => {
      throw e;
    });
  }

  async clearSubscribe({filter = (value) => true} = {}) {
    for (const subscribe in this._subscribes) {
      await this._unsubscribe(subscribe);
    }

    this._subscribes = {};
  }

  /**
   * 抽象方法, 当监听的时候执行, 防重复执行
   *
   * @param topic
   * @param success
   * @param message
   * @param complete
   * @param fail
   * @return {Promise<DeviceConnectProvide>}
   */
  async _subscribe(topic, {success, message, complete, fail} = {}) {
  }

  /**
   * 抽象方法, 当取消监听的时候执行, 防重复执行
   *
   * @param topic
   * @param success
   * @param error
   * @param complete
   * @param fail
   * @param index
   */
  async _unsubscribe(topic, {success, error, complete, fail, index} = {}) {
  }

  /**
   * 发送数据
   * @param topic
   * @param params
   * @param id
   * @param success
   * @param complete
   * @param fail
   * @return {Promise<void>}
   */
  async _publish(topic, params, {id, success, complete, fail} = {}) {
  }
}

class CompositeDeviceConnectProvide extends DeviceConnectProvide {
  /**
   * @type{Class<DeviceConnectProvide>[]}
   */
  static deviceConnectProvides = [];

  /**
   * @type{DeviceConnectProvide[]}
   */
  _deviceConnectProvides = [];

  /**
   * @type {DeviceConnectProvide}
   * @private
   */
  _deviceConnectProvide;
  _connectType;

  constructor({deviceConnectProvides, connectType = 2} = {}) {
    super();

    this._connectType = connectType;

    if (deviceConnectProvides) {
      this._deviceConnectProvides = deviceConnectProvides;
    } else {
      this._deviceConnectProvides = CompositeDeviceConnectProvide.deviceConnectProvides.map(value => new value());
    }
  }

  async setConnectType(connectType) {
    const deviceConnectProvide = this._deviceConnectProvides.find(value => value.isSupport(connectType, this.config));

    //连接情况下 不允许更换连接方式
    if (this._connectType !== connectType) {
      this._connectType = connectType;

      if (this._deviceConnectProvide && this._deviceConnectProvide !== deviceConnectProvide && connectType !== 3) {
        await this._deviceConnectProvide.disconnect();
      }

      this._deviceConnectProvide = null;
    }

    if (!this._deviceConnectProvide) {
      this._deviceConnectProvide = deviceConnectProvide;
    }
  }

  get connectType() {
    return this._connectType;
  }

  /**
   * @param onConnect
   * @param onConnected
   * @param onReconnect
   * @param onDisconnect
   * @param onDisconnected
   * @param onError
   * @param timeout
   * @param config
   * @return Promise<DeviceConnectProvide>
   */
  async connect({onConnect, onConnected, onReconnect, onDisconnect, onDisconnected, onError, timeout, config} = {}) {
    this.config = config;

    if (!this._deviceConnectProvide) {
      await this.setConnectType(this._connectType);
    }

    if (this._deviceConnectProvide) {
      await this._deviceConnectProvide.connect({
        onConnect,
        onConnected,
        onReconnect,
        onDisconnect,
        onDisconnected,
        onError,
        timeout,
        config
      });
      return this;
    }

    throw WebError.code(defaultError.CONNECT_ILLEGAL_ARGUMENT, {
      msg: "未找到对应连接工具"
    });
  }

  async close(force = false) {
    for (const i in this._deviceConnectProvides) {
      const deviceConnectProvide = this._deviceConnectProvides[i];
      await deviceConnectProvide.close(force).catch(e => {
        console.warn("关闭通道失败", e);
      });
    }
  }

  get connected() {
    return this._deviceConnectProvide != null ? this._deviceConnectProvide.connected : false;
  }

  set codec(codec) {
    this._deviceConnectProvide.codec = codec;
  }

  get codec(){
    return this._deviceConnectProvide.codec;
  }

  get deviceConnectProvide() {
    return this._deviceConnectProvide;
  }

  async disconnect() {
    return this._deviceConnectProvide.disconnect();
  }

  get networkConnectProvide() {
    return this._deviceConnectProvide.networkConnectProvide ? this._deviceConnectProvide.networkConnectProvide : this;
  }

  async subscribe(topic, {success, message, complete, fail} = {}) {
    return this._deviceConnectProvide.subscribe(topic, {success, message, complete, fail});
  }

  async unsubscribe(topic, {success, index} = {}) {
    await this._deviceConnectProvide.unsubscribe(topic, {success, index});
  }

  async publish(topic, params, {id, success, complete, fail} = {}) {
    await this._deviceConnectProvide.publish(topic, params, {id, success, complete, fail});
  }

  isSupport(connectType) {
    return this._deviceConnectProvides.find(value => value.isSupport(connectType)) != null;
  }
}

export {DeviceConnectProvide, CompositeDeviceConnectProvide};